import React from 'react'

interface UseCheckMountedStatus {
  disable?: boolean
}

const useCheckMountedStatus = (args?: UseCheckMountedStatus) => {
  const { disable } = args || {}
  const isMounted = React.useRef(false)
  React.useEffect(() => {
    if (disable) {
      return
    }
    isMounted.current = true
  }, [disable])

  return isMounted.current
}

export default useCheckMountedStatus
